/**
 * Shared analytics event tracking helper.
 * Sends events to both Google Analytics (gtag) and Umami.
 * Safe to call even if gtag/umami is not loaded (e.g. during SSR or if analytics is disabled).
 */
export function trackEvent(eventName: string, params?: Record<string, string | number | boolean>) {
	if (typeof window === 'undefined') return;

	// Google Analytics 4 (via gtag)
	if ('gtag' in window) {
		(window as any).gtag('event', eventName, params);
	}

	// Umami Analytics
	if ((window as any).umami) {
		(window as any).umami.track(eventName, params);
	}
}
